module.exports = __webpack_public_path__ + "img/Highlight_Feature-D.0a3301e7.png";